import {
  PostApiSpoProductBenefitsBody,
  SpoProductBenefitsResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getProductBenefits = async ({
  language,
}: PostApiSpoProductBenefitsBody): Promise<SpoProductBenefitsResponse> =>
  apiBff.callBFF('POST', 'spo/product_benefits', { language });
